import { ref } from "vue";
import { $http } from "@/plugins/api";
import { createSharedComposable } from "@vueuse/core";
import { getApiClientUrl } from "@/config/runtimeConfig";
import { TargetedUser } from "./types/TargetedUsers";

export const useTargetedUsersStore = createSharedComposable(() => {
  const targetedUsers = ref<TargetedUser[]>([]);

  const getTargetedUsers = async ({
    globalOrganisationID,
    params,
  }: {
    globalOrganisationID: string;
    params: Record<string, string>;
  }): Promise<void> => {
    const filterParams = new URLSearchParams(params);
    const res = await $http.get(
      `${getApiClientUrl()}/v3/pt/history/globalOrganisationID/${globalOrganisationID}/stats/targets?${filterParams.toString()}`,
    );
    targetedUsers.value = res.data.data;
  };

  const resetTargetedUsers = () => {
    targetedUsers.value = [];
  };

  return {
    targetedUsers,
    getTargetedUsers,
    resetTargetedUsers,
  };
});
